module.exports = __webpack_public_path__ + "a588d287.png";